import React from 'react';

import { useNavigate } from 'react-router-dom';

import { BankOutlined } from '@ant-design/icons';

import moment from 'moment';

import configData from '../config/index';

const LoanPaymentHistoryRow = ({ data, isLastPending }) => {
  const navigate = useNavigate();
  const isBnpl = configData.getTenant() === 'lightrx';
  const isPaid = !!data.datePaid;
  const paymentStatus = !data.datePaid ? 'pending' : data.nsfFlag ? 'returned' : 'paid';
  const goToScheduledPaymentDetails = () => {
    if (paymentStatus === 'pending') {
      navigate(`/account/${data.loanId}/payment`);
    }
  };
  return (
    <div
      className={`row loanPaymentHistoryRow ${isLastPending ? 'lastPending' : ''} ${paymentStatus}`}
      onClick={goToScheduledPaymentDetails}
    >
      <div>
        <div className="loanPaymentHistoryResult">
          <div className={`loanPaymentHistoryBadge ${paymentStatus}`} />
          <div className={`loanPaymentHistoryStatus ${paymentStatus}`}>{paymentStatus}</div>
          <div className="loanPaymentHistoryDate">
            {moment(isPaid ? data.datePaid : data.scheduleDate).format('MMMM D, YYYY')}
          </div>
        </div>
        <div className="loanPaymentHistoryBank">
          <BankOutlined />
          {data.maskedIdentifier
            ? `Account Ending In ${data.makedIdentifier}`
            : `Account Ending In ${data.accountNumber.replaceAll('*', '')}`}
        </div>
      </div>
      <div>
        <div className="loanPaymentHistoryValue">
          {data.totalAmount.toLocaleString('en-US', {
            style: 'currency',
            currency: 'USD',
          })}
        </div>
      </div>
    </div>
  );
};

export default LoanPaymentHistoryRow;
